import { createAction, props } from '@ngrx/store';
import { nwmlsDetailPayload, nwmlsListPayload } from './nwmls.model';

export const fetchNwmlsList = createAction('[Data] Fetch Nwmls List', props<{ payload: nwmlsListPayload }>());
export const fetchNwmlsListSuccess = createAction('[Data] Fetch Nwmls List Success', props<{ response: any }>());
export const fetchNwmlsListFailure = createAction('[Data] Fetch Nwmls List Failure', props<{ error: string }>());

export const fetchNwmlsDetail = createAction('[Data] Fetch Nwmls Detail', props<{ payload: nwmlsDetailPayload }>());
export const fetchNwmlsDetailSuccess = createAction('[Data] Fetch Nwmls Detail Success', props<{ response: any }>());
export const fetchNwmlsDetailFailure = createAction('[Data] Fetch Nwmls Detail Failure', props<{ error: string }>());
